import { render } from "./billing-comp.vue?vue&type=template&id=66146dc9&scoped=true"
import script from "./billing-comp.vue?vue&type=script&lang=js"
export * from "./billing-comp.vue?vue&type=script&lang=js"

import "./billing-comp.vue?vue&type=style&index=0&id=66146dc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66146dc9"]])

export default __exports__